import Component from '@glimmer/component';

interface UiInputGroupTextareaSignature {
  Element: HTMLTextAreaElement;
  Args: {
    Named: {
      id: string;
      hasError?: boolean;
      ariaDescribedby?: string;
      iconRight?: string;
    };
  };
  Blocks: {
    default: [];
  };
}

export default class UiInputGroupTextareaComponent extends Component<UiInputGroupTextareaSignature> {}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Ui::InputGroup::Textarea': typeof UiInputGroupTextareaComponent;
    'ui/input-group/textarea': typeof UiInputGroupTextareaComponent;
  }
}
